module.exports = __webpack_public_path__ + "img/1.1f75ef05.jpg";